<div class="container p-4 bg-whitesmoke">
  <app-breadcrumb [activePanel]="'settings'"></app-breadcrumb>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="mt-3 text-muted">Loading settings...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="!loading && error" class="alert alert-danger rounded">
    <mat-icon class="me-2">error</mat-icon>
    {{ error }}
  </div>

  <!-- Success State -->
  <div *ngIf="!loading && success" class="alert alert-success rounded">
    <mat-icon class="me-2">check_circle</mat-icon>
    {{ success }}
  </div>

  <!-- Settings Form -->
  <form *ngIf="settingsForm && !loading" [formGroup]="settingsForm" class="shadow-sm p-4 bg-white rounded">

    <div class="mb-3">
  <label class="form-label fw-bold d-block">Theme</label>
  <div
    class="d-flex align-items-center justify-content-between p-3 rounded border shadow-sm"
    style="cursor: pointer;"
    (click)="openThemePicker()"
  >
    <div class="d-flex align-items-center">
      <div
        class="theme-preview me-3 rounded"
        [style.background]="settingsForm.value.themeColor"
        style="width: 40px; height: 40px;"
      ></div>
      <span>{{ settingsForm.value.themeColor ? 'Custom Theme Selected' : 'Default Theme' }}</span>
    </div>
    <mat-icon color="primary">palette</mat-icon>
  </div>
</div>



    <div class="mb-3">
      <label class="form-label fw-bold">Language</label>
      <input matInput formControlName="language" placeholder="en, fr, es, ..." class="form-control">
    </div>

    <div class="form-check mb-3">
      <input type="checkbox" formControlName="notifications" class="form-check-input" id="notifications">
      <label class="form-check-label" for="notifications">Enable Notifications</label>
    </div>

    <div class="form-check mb-3">
      <input type="checkbox" formControlName="isDarkMode" class="form-check-input" id="darkMode">
      <label class="form-check-label" for="darkMode">Enable Dark Mode</label>
    </div>

    <div class="mb-3">
      <label class="form-label fw-bold">Logo URL</label>
      <input matInput formControlName="logoUrl" placeholder="https://example.com/logo.png" class="form-control">
    </div>

    <!-- Actions -->
    <div class="d-flex justify-content-between mt-4">
      <button mat-raised-button color="primary" type="button" (click)="saveSettings()">
        <mat-icon class="me-2">save</mat-icon> Save Settings
      </button>
      <button mat-stroked-button color="warn" type="button" (click)="resetSettings()">
        <mat-icon class="me-2">delete</mat-icon> Reset / Delete
      </button>
    </div>
  </form>
</div>